import React, { Suspense, useRef, useState, useEffect, useMemo } from 'react'
import './App.css';
import * as THREE from 'three';
import { Stats, Html, Center, OrbitControls, MeshDistortMaterial } from '@react-three/drei';
import { Canvas, extend, useThree, useFrame } from '@react-three/fiber'
import { useLoader } from '@react-three/fiber'
import { useTexture } from '@react-three/drei';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { Particles } from './ParticleSystems';

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass'
import { TextureLoader } from 'three/src/loaders/TextureLoader.js';
import { MeshBasicMaterial } from 'three';
import { MeshStandardMaterial } from 'three';
import { Vector3 } from 'three';

extend({ EffectComposer, RenderPass, UnrealBloomPass });


function Effect({ down }) {
  const composer = useRef()
  const { scene, gl, size, camera } = useThree()
  const aspect = useMemo(() => new THREE.Vector2(size.width, size.height), [size])
  useEffect(() => void composer.current.setSize(size.width, size.height), [size])
  useFrame(() => composer.current.render(), 1)
  return (
    <>
    <effectComposer ref={composer} args={[gl]}>
      <renderPass attachArray="passes" scene={scene} camera={camera} />
      <unrealBloomPass attachArray="passes" args={[aspect, 2, 0.5, 0]} />
    </effectComposer>
    </>
  )
}



const params = new URLSearchParams(window.location.search);
const viewer = params.get('viewer');
let viewerIsOwner = false;
let objkt = parseInt(params.get("objkt"), 10);
// let objkt = 521339;

const query = `
query Objkt($id: bigint!) {
  hic_et_nunc_token_by_pk(id: $id) {
    token_holders(where: {quantity: {_gt: "0"}}, order_by: {id: asc}) {
      quantity
      holder {
        address
        name
      }
    }
  }
}
`;


async function fetchGraphQL(operationsDoc, operationName, variables) {
  const result = await fetch(
    "https://api.hicdex.com/v1/graphql",
    {
      method: "POST",
      body: JSON.stringify({
        query: operationsDoc,
        variables: variables,
        operationName: operationName
      })
    }
  );

  return await result.json();
}

async function doFetch() {
  if(!objkt) return;
  const { errors, data } = await fetchGraphQL(query, "Objkt", {"id":objkt});
  if (errors) {
    console.error(errors);
  }
  else 
  {
    const result = data.hic_et_nunc_token_by_pk;
    console.log({ result });
    return result;
  }
}

function checkViewerIsOwner(data) {
  if(!data || !data.token_holders) return;
  if (data.token_holders.some((e) => e.holder.address === viewer)) {
    console.log(`viewer IS owner`);
    viewerIsOwner = true;
  } else {
    console.log(`viewer is NOT owner`);
  }
  //console.log({ OBJKT: data });
}

function changeData(data) {
  console.log("Refreshing");
  if(!data || !data.token_holders) return;

  let curData = data.token_holders.map((holder) => { 
    return holder.holder.name ? holder.holder.name : 
                                holder.holder.address.substr(0,4) + "..." + holder.holder.address.substr(-4);
  });
  
  console.log(curData)
  return curData;
}


let amount = 0;
// function RecursiveBox({size, pos, depth}) {
//   amount++;
//   console.log(amount)
//   if(depth > 0) 
//     return (
//     <mesh position={pos}>
//       <boxGeometry args={size} />
//       <meshBasicMaterial color={'hsl(' + Math.random()*345 + ', 100%, 50%)'} />
//     </mesh>
//   );

//   // let lSize = [size[0] * Math.random(), size[1], size[2]];
//   // let rSize = [size[0] - lSize[0], size[1], size[2]];
//   let sizeNew = [size[0] / 2, size[1] / 2, size[2] / 2];

//   let ldPos = [pos[0] - size[0]/4,  pos[1] - size[1] / 4, pos[2]];
//   let luPos = [pos[0] - size[0]/4,  pos[1] + size[1] / 4, pos[2]];
//   let rdPos = [pos[0] + size[0]/4,  pos[1] - size[1] / 4, pos[2]];
//   let ruPos = [pos[0] + size[0]/4,  pos[1] + size[1] / 4, pos[2]];
//   // console.log(lSize, lPos)
//   return <>
//     <RecursiveBox size={sizeNew} pos={ldPos} depth={depth+1}/>
//     <RecursiveBox size={sizeNew} pos={luPos} depth={depth+1}/>
//     <RecursiveBox size={sizeNew} pos={rdPos} depth={depth+1}/>
//     <RecursiveBox size={sizeNew} pos={ruPos} depth={depth+1}/>
//   </>
// }
function getCanvasTexture(children, color) {
  console.log(children)
  const fontSize = 1024;

  const canvas = document.createElement('canvas');
  canvas.width = 2048;
  canvas.height = 2048;
  const context = canvas.getContext('2d');

  context.font = `bold ${fontSize}px -apple-system, helvetica, ubuntu, roboto, arial, sans-serif`;
  context.textAlign = 'center';
  context.textBaseline = 'middle';
  context.fillStyle = color;
  context.fillText(children, 1024, canvas.height / 2, 2000);
  return canvas;

}

function Bilboard({text, position}) {
  const ref=useRef();
  
  const canvas = useMemo(() => {
    return getCanvasTexture(text, "grey")
  }, [text])

  const texture = useRef();
  let oldTime = 0;
  
  useFrame(({ clock, raycaster, mouse, camera }) => {
    texture.current.offset.x = clock.getElapsedTime() / 10;
    ref.current.material.opacity -= (clock.elapsedTime - oldTime);

    raycaster.setFromCamera(mouse, camera);

    const intersects = raycaster.intersectObjects([ref.current], false );
    if(intersects.length > 0)
    {
      ref.current.material.opacity = 0.8;
    }

    oldTime = clock.getElapsedTime();
  })
  return (
      <mesh position={position} ref={ref}>
        <cylinderGeometry args={[5, 5, 2, 64, 1, true]} />
        <meshBasicMaterial transparent attach="material" depthWrite={false}  opacity={0.4}>
          <canvasTexture
            attach="map"
            repeat={[4, 1]}
            image={canvas}
            premultiplyAlpha
            ref={texture}
            wrapS={THREE.RepeatWrapping}
            wrapT={THREE.RepeatWrapping}
            onUpdate={(s) => (s.needsUpdate = true)}
          />
        </meshBasicMaterial>
      </mesh>);
}

function Core() {
  const ref = useRef();
  const { camera } = useThree();
  camera.position.set(0, 10, 20);

  useFrame(({clock}) => {
    ref.current.rotation.y = clock.elapsedTime*5;
  })

  return (
  <mesh ref={ref} position={[0,9.5,0]}>
    <boxGeometry args={[0.3,20,0.3]} />
    <meshBasicMaterial color={'#7777aa'} />
  </mesh>)
}


function App() {
  const [id, setId] = useState(0);
  const [characters, set] = useState([]);
  const floors = [0,1,2,3,4,5,6,7,8,9,10];

  useEffect(() => {
    doFetch(objkt)
      .then((data) => changeData(data))
      .then((char) => set(char));
  }, [id])


  return (
    <div id="wrapper" onMouseDown={() => {console.log("PRESSED")}}>
  <Canvas>
    <Effect />
      <ambientLight intensity = {0.1} />
      <pointLight position={[0,-10,0]} intensity={1.0} color={'white'}/>
      <Suspense fallback={null}>
        <Particles count={500}/>
        <Core />
        {floors.map((i) =>
          <>
          <mesh rotation={[-Math.PI / 2,0,0]} position={[0,-0.5 + i*2,0]}>
            <circleGeometry args={[4,32]} />
            <meshBasicMaterial color={0x44aaff} transparent={true} opacity={0.4}/>
          </mesh>
          <Bilboard text={characters ? characters[i] : ' '} position={[0, 0.5 + i*2,0]}/>
          </>
          )
        }
      </Suspense>

    <OrbitControls target={new THREE.Vector3(0,10,0)}/> 
    {/* <Stats /> */}
  </Canvas>
  </div>
  );
}

export default App;
